export class CompanyModalController {
  private static instance: CompanyModalController;
  private listeners: Set<(isOpen: boolean) => void> = new Set();

  static getInstance(): CompanyModalController {
    if (!CompanyModalController.instance) {
      CompanyModalController.instance = new CompanyModalController();
    }
    return CompanyModalController.instance;
  }

  subscribe(listener: (isOpen: boolean) => void): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }

  show(): void {
    this.listeners.forEach(listener => listener(true));
  }

  hide(): void {
    this.listeners.forEach(listener => listener(false));
  }
} 